<adapt-dialog [maxWidth]="600"
              [fitHeight]="true">
    <h2 adapt-dialog-title>{{hasExistingVision ? 'Recapture' : 'Capture'}} vision</h2>
    <div adapt-dialog-content
         class="d-flex flex-column h-100 gap-2"
         *adaptLoading="!isInitialised">
        <div>Select the team members who will participate in capturing the vision.</div>
        @for (person of teamMembers; track person.personId) {
            <div class="d-flex gap-2 align-items-center"
                 data-test="vision-participant-checkbox">
                @let personCannotEditVision = !personCanEditVision(person);
                <dx-check-box [value]="isParticipating(person.personId)"
                              (valueChange)="onParticipationChange(person.personId, !!$event)"
                              [disabled]="personCannotEditVision"></dx-check-box>
                <adapt-link-person [person]="person"
                                   [showImage]="true"
                                   imageSize="sm"
                                   [linkDisabled]="true"
                                   (click)="!personCannotEditVision && toggleParticipation(person.personId)"
                                   [attr.role]="personCannotEditVision ? null : 'button'"></adapt-link-person>
                @if (personCannotEditVision) {
                    <span class="text-muted small">(no permission to edit)</span>
                }
            </div>
        }

        @if (hasExistingVision) {
            <div class="mt-3 d-flex flex-column">
                @if (captureInProgress) {
                    <p>There is currently a capture in progress and some participants have not yet completed their vision.</p>
                } @else {
                    <p>The team vision has already been captured.</p>
                }

                <p>Recapturing updates the existing entries, requires previous participants
                    to reconfirm their vision, and removes statements from anyone no longer participating.</p>
                <p><b>Are you sure you want to recapture?</b></p>
            </div>
        }
    </div>
    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveText]="hasExistingVision ? 'Recapture' : 'Capture'"
                                   [saveIsDisabled]="participatingMemberIds.length === 0"
                                   [saveBlockingClick]="captureVision"
                                   (cancelClick)="cancel()">
    </adapt-standard-dialog-buttons>
</adapt-dialog>
